import brandConfig from "../shared/brandConfig.json";

export const BRAND_NAME = brandConfig.name;
export const BRAND_TITLE = brandConfig.title;
export const BRAND_TAGLINE = brandConfig.tagline;
export const BRAND_SITE_TITLE = brandConfig.siteTitle;
export const BRAND_DESCRIPTION = brandConfig.description;
export const BRAND_OG_DESCRIPTION = brandConfig.ogDescription;
export const BRAND_SUPPORT_EMAIL = brandConfig.supportEmail;
export const BRAND_SITE_URL = brandConfig.siteUrl;
export const BRAND_EMAIL_LOGO_PATH = brandConfig.emailLogoPath;

export const BRAND_WORDMARK_VARIANTS = {
  navbar: {
    fontSize: { xs: "1.45rem", md: "1.7rem", lg: "1.9rem" },
    letterSpacing: "-0.05em",
    lineHeight: 1,
    iconSize: { xs: 26, md: 30, lg: 32 },
  },
  compact: {
    fontSize: "1.55rem",
    letterSpacing: "-0.05em",
    lineHeight: 1,
    iconSize: 28,
  },
  minimal: {
    fontSize: { xs: "1.5rem", md: "1.75rem" },
    letterSpacing: "-0.05em",
    lineHeight: 1,
    iconSize: { xs: 26, md: 30 },
  },
  heroInline: {
    fontSize: "inherit",
    letterSpacing: "-0.05em",
    lineHeight: 1,
    iconSize: 0,
  },
};
